<template>
  <div class="container">
    <div class="handle-wrapper">
      <Input v-model="searchText" search placeholder="搜索原材料..." @on-change="searchMaterial"
        style="width: 250px; margin-right: 30px">
      <Button slot="append" icon="ios-search" @click="searchMaterial"></Button>
      </Input>
      <Select @on-change="selectStatusMethod" v-model="selectStatus" style="width: 100px; margin-right: auto">
        <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <span>共{{ totalRows }}条</span>
      <Page :total="totalRows" :page-size="50" @on-change="loadMaterial" show-total simple style="margin-right: 24px" />
      <Button type="success" style="margin-right: 20px" :loading="exportMaterialLoading"
        @click="exportMaterial()">导出原材料</Button>
      <Button type="primary" @click="openEditMaterialDrawer()">新增原材料</Button>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table border :loading="tableLoading" :columns="columns" :data="tableData" :height="tableHeight"></Table>
    </div>
    <EditRawMaterialDrawer ref="EditRawMaterialDrawer" />
    <MaterialPurchaseDrawer ref="MaterialPurchaseDrawer" v-on:editSuccess="loadMaterial" />
  </div>
</template>

<script>
import EditRawMaterialDrawer from "./EditRawMaterialDrawer";
import MaterialPurchaseDrawer from "./MaterialPurchaseDrawer.vue";
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import _ from "lodash";
import axios from "@/utils/axios";
import dayjs from "dayjs";

export default {
  name: "Material",
  components: { EditRawMaterialDrawer, MaterialPurchaseDrawer },
  props: {},
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      filterQuery: { limit: 50 },
      tableHeight: 300,
      exportMaterialLoading: false,
      selectStatus: 'unInvalid',
      statusList: [
        {
          value: "all",
          label: "全部",
        },
        {
          value: "unInvalid",
          label: "可用",
        },
        {
          value: "invalid",
          label: "禁用",
        },
      ],
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            )
        },
        // {
        //   title: "采购",
        //   key: "purchase",
        //   align: "center",
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "h4",
        //         {
        //           props: {
        //             type: "text",
        //             size: "small",
        //           },
        //           style: {
        //             color: "#42b983",
        //             cursor: "pointer",
        //           },
        //           on: {
        //             click: () => {
        //               this.$refs.MaterialPurchaseDrawer.openDrawer(params.row);
        //             },
        //           },
        //         },
        //         "采购"
        //       ),
        //     ]);
        //   },
        // },
        {
          title: "材料名字",
          width: 200,
          key: "code",
          render: (h, params) => {
            if (
              this.currentUser.superAdmin ||
              arrayIntersection(
                ["purchase", "factoryLeader", "allFactoryLeader"],
                this.currentUser.simpleRole
              ).length > 0
            ) {
              return h("div", [
                h(
                  "h4",
                  {
                    props: {
                      type: "text",
                      size: "small"
                    },
                    style: {
                      color: "#42b983",
                      cursor: "pointer"
                    },
                    on: {
                      click: () => {
                        this.$refs.EditRawMaterialDrawer.openDrawer(
                          "raw",
                          params.row
                        );
                      }
                    }
                  },
                  params.row.name
                )
              ]);
            } else {
              return h("h4", params.row.name);
            }
          }
        },
        {
          title: "用于母液",
          key: "usedForSemi",
          width: 140,
          align: "center",
          render: (h, params) => {
            if (params.row.usedForSemi) return h("span", "是");
          }
        },
        {
          title: "用于复配",
          key: "usedForProduct",
          width: 140,
          align: "center",
          render: (h, params) => {
            if (params.row.usedForProduct) return h("span", "是");
          }
        },
        {
          title: "型号",
          width: 200,
          key: "model"
        },
        {
          title: "是否被禁用",
          key: "invalid",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  color: "#ed4014"
                }
              },
              params.row.invalid ? "是" : ""
            );
          }
        }
      ]
    };
  },
  computed: {
    ...mapState({
      tableData: state => state.material.materials,
      totalRows: state => state.material.totalCounts,
      factoryList: state => state.factory.factoryList,
      currentUser: state => state.auth.currentUser
    })
    // dynamicColumns: function () {
    //   const facCol = this.factoryList.map((e) => {
    //     return {
    //       title: e.name,
    //       key: e._id,
    //       width: 100,
    //       align: "right",
    //       render: (h, params) => {
    //         const pricePerFac = params.row.price;
    //         if (pricePerFac.length > 0) {
    //           const factoryPrice = pricePerFac.find((x) => x.factory === e._id);
    //           if (factoryPrice) return h("span", factoryPrice.latestPrice);
    //           return null;
    //         }
    //       },
    //     };
    //   });

    //   const remainCols = [
    //     {
    //       title: "用于母液",
    //       key: "usedForSemi",
    //       sortable: true,
    //       render: (h, params) =>
    //         h("span", params.row.usedForSemi ? "是" : null),
    //     },
    //     {
    //       title: "用于复配",
    //       key: "usedForProduct",
    //       sortable: true,
    //       render: (h, params) =>
    //         h("span", params.row.usedForProduct ? "是" : null),
    //     },
    //   ];

    //   return [...this.columns, ...facCol, ...remainCols];
    // },
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getMaterials: "material/getMaterialsAction"
      // getRawMaterialWithPrice: "material/getRawMaterialWithPriceAction",
    }),
    openEditMaterialDrawer() {
      this.$refs.EditRawMaterialDrawer.openDrawer("raw");
    },
    async loadMaterial(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        skip: this.page * 50,
        type: "raw",
      };
      if (this.searchText) {
        this.filterQuery.name = this.searchText;
      } else {
        delete this.filterQuery.name;
      }
      switch (this.selectStatus) {
        case 'unInvalid':
          this.filterQuery.invalid = false
          break;
        case 'invalid':
          this.filterQuery.invalid = true
          break;
        case 'all':
          delete this.filterQuery.invalid
          break;
      }
      try {
        this.tableLoading = true;
        await this.getMaterials(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchMaterial: _.debounce(function () {
      this.page = 0;
      this.loadMaterial();
    }, 1000),
    selectStatusMethod(status) {
      this.loadMaterial();
    },
    // 导出原材料数据
    async exportMaterial() {
      this.exportMaterialLoading = true;
      try {
        const res = await axios.get(`/export_material`, {
          responseType: "blob",
        });
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `原材料数据${dayjs().format("MM-DD-YYYY")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        this.exportMaterialLoading = false;
      } catch (error) {
        this.$Message.error(`导出失败: ${error}`);
        this.exportMaterialLoading = false;
      }
    },
  },
  created() {
    this.loadMaterial();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  }
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>
